import axios from 'axios';
import { Dokument, DokumentInfo } from './types';
import { getKjederegAdminApiUrl } from '../../';

const baseUrl = getKjederegAdminApiUrl() + '/docs';

async function list(): Promise<DokumentInfo[]> {
  const response = await axios.get(baseUrl);
  return response.data;
}

async function get(slug: string): Promise<Dokument> {
  const response = await axios.get(`${baseUrl}/${encodeURIComponent(slug)}`);
  return response.data;
}

/**
 * Henter et bilde med token (img-tagger sender ikke Authorization) og returnerer en object-URL.
 * Kalleren må frigjøre den med URL.revokeObjectURL.
 */
async function getImageUrl(slug: string, path: string): Promise<string> {
  const encodedPath = path.split('/').map(encodeURIComponent).join('/');
  const response = await axios.get(`${baseUrl}/${encodeURIComponent(slug)}/assets/${encodedPath}`, {
    responseType: 'blob',
  });
  return URL.createObjectURL(response.data);
}

export default { list, get, getImageUrl };
